export const DAILY_ERRORS_TITLE = 'Daily Errors Report';
